'use client';

import PageHero from '@/components/_rebrand/heroes/PageHero';
import { GlobalContext } from '@/context';
import { useContext, useEffect } from 'react';
import { FlexPageHeroProps } from './FlexPageHero.types';
import { mapEntryToPageHeroProps } from './FlexPageHero.utils';

const FlexPageHero = ({ entry }: FlexPageHeroProps) => {
  const { toggleInvertedNav } = useContext(GlobalContext);

  useEffect(() => {
    toggleInvertedNav(true);

    return () => {
      toggleInvertedNav(false);
    };
  }, [toggleInvertedNav]);

  const pageHeroProps = mapEntryToPageHeroProps(entry);

  return <PageHero {...pageHeroProps} />;
};

export default FlexPageHero;
